import { render } from "./ViewDeltaLog.vue?vue&type=template&id=67394f45&scoped=true"
import script from "./ViewDeltaLog.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDeltaLog.vue?vue&type=script&setup=true&lang=js"

import "./ViewDeltaLog.vue?vue&type=style&index=0&id=67394f45&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67394f45"],['__file',"resources/js/modules/delta-logs/components/ViewDeltaLog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67394f45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67394f45', __exports__)) {
    api.reload('67394f45', __exports__)
  }
  
  module.hot.accept("./ViewDeltaLog.vue?vue&type=template&id=67394f45&scoped=true", () => {
    api.rerender('67394f45', render)
  })

}


export default __exports__